import { z } from "zod";
export const pipeMetadataSchema = z.object({
    event: z.string(),
    // comes from Pipe webhooks
    data: z.object({
        id: z.coerce.string(),
        type: z.string().optional(),
        url: z.string().optional(),
        snapshotUrl: z.string().optional(),
        duration: z.string().optional(),
        width: z
            .union([
            z.string(),
            // We were getting some schema check failures because a number was found
            // in this field. It's unclear how that happened, but it's likely that
            // Pipe just sometimes returns numbers here.
            z.number(),
        ])
            .optional(),
        height: z
            .union([
            z.string(),
            // We were getting some schema check failures because a number was found
            // in this field. It's unclear how that happened, but it's likely that
            // Pipe just sometimes returns numbers here.
            z.number(),
        ])
            .optional(),
        // a JSON encoded string of PipeCustomPayload
        payload: z.string().optional(),
        cdn: z
            .object({
            cdnRecordingUrl: z.string().optional(),
            cdnSnapshotUrl: z.string().optional(),
        })
            .optional(),
        acl: z.string().optional(),
        audioCodec: z.string().optional(),
        bucket: z.string().optional(),
        cam_name: z.string().optional(),
        checksum_md5: z.string().optional(),
        checksum_sha1: z.string().optional(),
        cutToLength: z.number().optional(),
        dateTime: z.string().optional(),
        httpReferer: z.string().optional(),
        ip: z.string().optional(),
        mic_name: z.string().optional(),
        orientation: z.string().optional(),
        region: z.string().optional(),
        s3UploadStatus: z.string().optional(),
        size: z.number().optional(),
        timeZone: z.string().optional(),
        ua: z.string().optional(),
        videoCodec: z.string().optional(),
        videoName: z.string().optional(),
    }),
});
